import { render, staticRenderFns } from "./TheNotificationCenter.vue?vue&type=template&id=95c68c80"
import script from "./TheNotificationCenter.vue?vue&type=script&lang=js"
export * from "./TheNotificationCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports